module.exports = require('./helpers/bundle-url').getBundleURL('8X01H') + "logo-dark.eefe0b7f.svg";